// const loadGA = () => {
//   (function(i, s, o, g, r, a, m) {
//     i['GoogleAnalyticsObject'] = r;
//     i[r] = i[r] || function () { // eslint-disable-line
//       (i[r].q = i[r].q || []).push(arguments); // eslint-disable-line
//     }, i[r].l = 1 * new Date(); // eslint-disable-line
//     a = s.createElement(o), // eslint-disable-line
//       m = s.getElementsByTagName(o)[0]; // eslint-disable-line
//     a.async = 1;
//     a.src = g;
//     m.parentNode.insertBefore(a, m);
//   })(window, document, 'script', 'https://www.google-analytics.com/analytics.js', 'ga');
// }

const initialize = () => {
  // loadGA();
  // const gaTrackingID = process.env.GA_TRACKING_ID;
  // window.ga('create', {
  //   trackingId: gaTrackingID,
  //   cookieDomain: 'auto',
  //   siteSpeedSampleRate: 30,
  // });
  if (!window._czc) {
    window._czc = {
      push: () => {}
    }
  }
};

const set = fieldsObject => {
  window._czc.push(['_setCustomVar', fieldsObject]);
};

const setDimension = ({ key, value }) => {
  window._czc.push(['_setCustomVar', key, value]);
};

const setUserId = userId => {
window._czc.push(['_setCustomVar', 'user_id', userId]);
};

const registerProperties = propertyObject => {
window._czc.push(['_setCustomVar', propertyObject]);
};

const pageview = ({ path = '', title = '', location = '', otherParams = {} }) => {
  path = path.replace(/\/\d+/g, ''); // To remove ID from URL before loging in GA
  // window.ga('send', {
  //   hitType: 'pageview',
  //   page: path,
  //   title,
  //   location,
  // });
  window._czc.push(['_trackPageView', path])
};

// @otherParams is a object of  key:value pair
// have to see Object.values(otherParams)
const event = ({ category = '', action, otherParams = {} }) => {
  if ( !action) {
    console.error('args.action is required in event()');
    return;
  }
  // TODO check if there is support for custom parameters in Umeng
  window._czc.push(['_trackEvent', category, action, ...Object.values(otherParams)])
  // window.ga('send', {
  //   hitType: 'event',
  //   eventCategory: category,
  //   eventAction: action,
  //   eventLabel: label,
  //   nonInteraction,
  //   eventValue: value,
  // });
};

// @otherParams is a object of  key:value pair
const timings = ({ category = '', otherParams = {} }) => {
  // if (!category || !variable || !value || typeof value !== 'number') {
  //   console.error('args.category, args.variable ' +
  //         'AND args.value are required in timing() ' +
  //         'AND args.value has to be a number');
  //   return;
  // }
  // window.ga('send', {
  //   hitType: 'timing',
  //   timingCategory: category,
  //   timingVar: variable,
  //   timingValue: value,
  //   timingLabel: label,
  // });
};

const exception = ({ message = '', fatal = false }) => {
  // window.ga('send', 'exception', {
  //   exDescription: message,
  //   exFatal: fatal,
  // });
}


export default {
  initialize,
  set,
  setDimension,
  setUserId,
  registerProperties,
  pageview,
  event,
  exception,
  timings
};
